import { useTranslation } from 'react-i18next';
import { Typography } from '@legacy/components/mui-components';

export const NoResults = () => {
  const { t } = useTranslation('notificationCenter');
  return (
    <Typography
      fontStyle="italic"
      data-automation-id="NotificationNoResultsMessage"
    >
      {t('NotificationNoResultsText')}
    </Typography>
  );
};
